import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

export const IconContainer = styled.span`
  line-height: 62.5%;
  font-size: 1.6rem;
`;

export const Info = styled.div`
  display: grid;
  min-width: 0;
`;

export const Email = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BrokenMessage = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  color: ${({ theme }) => theme.palette.error.main};
`;

export const DialogHeader = styled.div`
  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};

  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;

export const DialogFooter = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;
